import { sendFeedback } from '../../services/userVoiceReports';
import TailoredActionName from '../../store/schema/telemetry/TailoredActionName';
import populateFeedbackDataPoint from 'owa-txp/lib/utils/telemetry/populateFeedbackDataPoint';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';
import { TxpDatapoint } from 'txp-data';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';

/**
 * Telemetry callback when 'send feedback' clicked with feedbackDataPoint
 */
export default function onSendFeedbackHandler(
    onFeedbackClicked: (txpDatapoint: TxpDatapoint, datapointName: string) => void,
    entityNamesMap: number,
    origin: string,
    txpStatus: TxpStatus
) {
    sendFeedback();

    if (onFeedbackClicked) {
        const dataPoint = populateFeedbackDataPoint(
            TailoredActionName.Feedback,
            entityNamesMap,
            origin,
            txpStatus
        );
        onFeedbackClicked(dataPoint, TxpDataPointNames.TXPUserVoice);
    }
}
